module.exports = __webpack_public_path__ + "static/media/vercel.00aabdc8.svg";